import React from 'react'
import ReactDOM from 'react-dom/client'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import App from './app/App'

import './styles/base.css'
import './styles/typography.css'
import './styles/forms.css'
import './styles/buttons.css'
import './styles/auth.css'
import './styles/layout.css'
import './styles/vehicle-listing.css'
import './styles/vehicle-details.css'
import './styles/swiper.css'
import './styles/chat.css'
import './styles/components.css'
import 'react-tippy/dist/tippy.css'

import QueryProvider from 'app/providers/QueryProvider.js'

const root = ReactDOM.createRoot(document.getElementById('root'))

if ('serviceWorker' in navigator) {
  // Check if service worker can be registered
  navigator.serviceWorker
    .register('/sw.js')
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope)
    })
    .catch((error) => {
      console.log('Service Worker registration failed:', error)
    })
}

// One-time cleanup: remove orphaned Redux-era encrypted_vehicleDetails key
// (superseded by Zustand vehicleStore's own 'vehicleDetails' persist key)
try {
  if (localStorage.getItem('encrypted_vehicleDetails')) {
    localStorage.removeItem('encrypted_vehicleDetails')
  }
} catch (e) {
  // ignore storage errors
}

root.render(
  <QueryProvider>
    <App />
    <ToastContainer />
  </QueryProvider>,
)
